// src/utils/reader-conversation.js
// REFACTORED (Phase 2): State extracted to composable.
// This shim preserves backward compatibility — all existing imports unchanged.
// New code should import from '@/composables/useReaderConversation' directly.

import { useReaderConversation } from '@/composables/useReaderConversation'

// Create a single shared instance for legacy consumers
const _shared = useReaderConversation()

// ─── UI State Refs ──────────────────────────────────────────────── //
export const lock_interface              = _shared.lock_interface
export const disable_insight_help        = _shared.disable_insight_help
export const ReadingSessionID            = _shared.ReadingSessionID
export const loadingHeadsUpMessage       = _shared.loadingHeadsUpMessage

// ─── Reading State Refs ─────────────────────────────────────────── //
export const readingTitle                = _shared.readingTitle
export const readingPast                 = _shared.readingPast
export const readingPresent              = _shared.readingPresent
export const readingFuture               = _shared.readingFuture
export const readingAdvice               = _shared.readingAdvice
export const readingPositions            = _shared.readingPositions
export const readingAnalysis             = _shared.readingAnalysis
export const readingIllustrationTitle    = _shared.readingIllustrationTitle
export const readingImage                = _shared.readingImage
export const ReadingSummaryTitle         = _shared.ReadingSummaryTitle
export const readingIsReady              = _shared.readingIsReady

// ─── Astrology State Refs ───────────────────────────────────────── //
export const astrologyTeaser             = _shared.astrologyTeaser
export const astrologySummary            = _shared.astrologySummary
export const astrologySummaryTitle       = _shared.astrologySummaryTitle
export const astrologySharedTitle        = _shared.astrologySharedTitle
export const astrologyImageCaption       = _shared.astrologyImageCaption
export const astrologyImage              = _shared.astrologyImage
export const astrologyTwoHourLimit       = _shared.astrologyTwoHourLimit

// ─── Shared Reading Refs ────────────────────────────────────────── //
export const sharedReadingTitle          = _shared.sharedReadingTitle
export const sharedReadingImage          = _shared.sharedReadingImage
export const sharedReadingPast           = _shared.sharedReadingPast
export const sharedReadingPresent        = _shared.sharedReadingPresent
export const sharedReadingFuture         = _shared.sharedReadingFuture
export const sharedReadingAdvice         = _shared.sharedReadingAdvice
export const sharedReadingSummaryTitle   = _shared.sharedReadingSummaryTitle
export const sharedReadingAnalysis       = _shared.sharedReadingAnalysis
export const sharedIllustrationTitle     = _shared.sharedIllustrationTitle

// ─── Chat UI Refs ───────────────────────────────────────────────── //
export const ChatInstructions            = _shared.ChatInstructions
export const LeftActionButton            = _shared.LeftActionButton
export const RightActionButton           = _shared.RightActionButton
export const StaticSuggestions           = _shared.StaticSuggestions
export const selecting_cards             = _shared.selecting_cards
export const resumeCardSelection         = _shared.resumeCardSelection
export const lessonSlotLabelsLive        = _shared.lessonSlotLabelsLive
export const lessonFullReply             = _shared.lessonFullReply
export const readingChargeReply          = _shared.readingChargeReply
export const lessonWelcome               = _shared.lessonWelcome
export const talkParting                 = _shared.talkParting
export const showLeftActionButton        = _shared.showLeftActionButton
export const showRightActionButton       = _shared.showRightActionButton

// ─── Other UI Refs ──────────────────────────────────────────────── //
export const scrollToShareTrigger        = _shared.scrollToShareTrigger
export const selectCardsFocusMessage     = _shared.selectCardsFocusMessage
export const currentWidget               = _shared.currentWidget
export const disablePageAfterEmailActivation = _shared.disablePageAfterEmailActivation
export const awaitEmailActivationWindow  = _shared.awaitEmailActivationWindow

// ─── Functions ──────────────────────────────────────────────────── //
export const resetAstrologyReadingState  = _shared.resetAstrologyReadingState
export const resetReadingState           = _shared.resetReadingState
export const connectWebSocket            = _shared.connectWebSocket
export const disconnectWebSocket         = _shared.disconnectWebSocket
export const ensureWebSocketConnected    = _shared.ensureWebSocketConnected
export const handleWebSocketMessages     = _shared.handleWebSocketMessages
export const revealSummaryHeldCards      = _shared.revealSummaryHeldCards
export const getWelcomeMessage           = _shared.getWelcomeMessage
export const ReaderConversation          = _shared.ReaderConversation
export const communicateCardSelected     = _shared.communicateCardSelected
export const getSunSign                  = _shared.getSunSign
export const formatPrettyDate            = _shared.formatPrettyDate
